var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAcandemy = function SvgAcandemy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11.936 17.341-4.73-2.788v3.417l4.902 2.858 5.154-2.442v-3.85z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.105 10.852 6.23 6.7 1.855 9.36 12 15.463l10.146-6.102-10.146-6.19-4.052 2.585 6.809 4.092zM2.748 11.253l2.299 1.392v5.144H2.748z"
  })));
};
export default SvgAcandemy;